import AddressRecord from "onnit-ui/lib/@types/interfaces/address/AddressRecord";
import Action from "../interfaces/Action";
import ActionTypeEnum from "../enums/ActionTypeEnum";

export default function addressReducer(state: AddressRecord[] = [], action: Action): AddressRecord[] {
    switch (action.type) {
        case ActionTypeEnum.ADDRESS_SET:
            return action.addresses;
        case ActionTypeEnum.ADDRESS_ADD:
            return [
                ...state,
                action.address,
            ];
        case ActionTypeEnum.ADDRESS_UPDATE:
            return [
                ...state.filter((addr) => addr.id !== action.address.id),
                action.address,
            ];
        default:
            return state;
    }
}
